module.exports = __webpack_public_path__ + "img/840.8ac977cd.svg";